<template>
    <div>
        <div class='table_style'
             v-loading="is_loading"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <table >
                <tr v-for='(item,index) in deviceDataList.list'   :key='index'>
                    <td v-for="(i,n) in item" :key='n' :style="{color:index == deviceDataList.alarmRed &&deviceDataList.alarmRed!=0?'red':'white',}">{{i}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'device_list',
        props:{
            deviceDataList:{
                type:Object,
                default:()=>{}
            },
        },
        data(){
            return {
                is_loading:false,
                alarmRed:''
            }
        },
        mounted(){
            // this.alarmRed =this.deviceDataList.alarmRed;
            // console.log(this.alarmRed,this.deviceDataList)
        },
        methods:{
            // alarmTime

        }
    }
</script>

<style scoped lang="less">
    .table_style{
        height:90%;
        overflow: hidden;
        // overflow-x: hidden;
        overflow-y: scroll;
        position: absolute;
        left: 10px;
        right: 10px;
        margin: 3px;
        table{
            width: 100%;
            background: #376ead;
            font-family: verdana,arial,sans-serif;
            font-size:12px;
            color:#333333;
            border-width: 1px;
            border-color: #666666;
            border-collapse: collapse;
            tr>th{
                border-width: 1px;
                padding: 8px;
                /*background-color: #0b373f;*/
                color: rgba(255,255,255,0.7);
                font-size: 14px;
                border:1px solid #797979;
                position: relative;
                &::before{
                    content:"";
                    position:absolute;
                    top:0px;
                    left:0px;
                    height:0;
                    width:0;
                    /*border-top:8px solid #041520;*/
                    border-top:8px solid #17c6ee;
                    border-right:8px solid transparent;
                }
                .sort_icon{
                    margin-left: 5px;
                    cursor: pointer;
                }

            }
            tr>td{
                border-width: 1px;
                padding: 8px;
                border-style: solid;
                border-color: #797979;
                color: rgba(255,255,255,0.8);

            }
        }
    }
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar
    {
        width: 4px;
        height: 4px;
        background-color: transparent;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    ::-webkit-scrollbar-track
    {
        //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 6px;
        background-color: transparent;
    }

    /*定义滑块 内阴影+圆角*/
    ::-webkit-scrollbar-thumb
    {
        border-radius: 6px;
        //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: rgba(0,70,195,0.6);
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/device_list.vue